var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: { size: "md", "hide-header": "", "hide-footer": "" },
          model: {
            value: _vm.modal,
            callback: function($$v) {
              _vm.modal = $$v
            },
            expression: "modal"
          }
        },
        [
          _c("h2", [_c("b", [_vm._v("Parabéns!")])]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("h6", [
            _vm._v(" Você possuí um pedido bonificado personalizado! ")
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: { block: "", variant: "success" },
              on: {
                click: function($event) {
                  _vm.modal = false
                }
              }
            },
            [_c("i", { staticClass: "fa fa-thumbs-up" }), _vm._v(" Ok")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8afc6f2a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8afc6f2a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/KitPersonalizado.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-8afc6f2a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/KitPersonalizado.vue
// module chunks = 2